import React from 'react';

function MedicalDeliveryServices() {
  const services = [
    {
      title: "Reliable and Timely Deliveries",
      description:
        "We ensure your critical medical shipments, such as hospital machinery or urgent medications, reach their destination on time, every time, maintaining smooth operations for healthcare providers.",
    },
    {
      title: "Comprehensive Coverage",
      description:
        "Our vast network allows us to serve hospitals, pharmacies, and clinics across the UK, reaching even the most remote locations with efficiency and reliability.",
    },
    {
      title: "Tailored Logistics Solutions",
      description:
        "We offer customised solutions to meet your specific logistics requirements, optimising efficiency and reducing costs for your supply chain.",
    },
    {
      title: "Commitment to Sustainability",
      description:
        "We embrace eco-friendly practices with fuel-efficient vehicles and innovative solutions to minimise our carbon footprint, supporting a greener future.",
    },
  ];

  const description = `Your trusted partner for specialised medical logistics solutions. At 1UKLogistics, we securely and efficiently transport essential medical equipment, supplies, and urgent medications, enabling healthcare professionals to provide exceptional care.`;

  const emergencyResponse = `In critical situations, our team is equipped to provide rapid response delivery services for life-saving resources. Whether it’s urgent medication for patients or emergency equipment for hospitals, we are available 24/7 to ensure swift and secure deliveries.`;

  const technologySolutions = `Leveraging advanced tracking and routing technology, we provide real-time updates on your shipments, ensuring transparency and peace of mind. Our tech-driven approach optimises routes, reduces delivery times, and enhances efficiency.`;

  return (
    <div>
      {/* Hero Section */}
      <div
        className="relative bg-cover bg-center h-[400px] md:h-[600px]"
        style={{ backgroundImage: "url('images/medical.png')" }}
      >
        <div className="absolute inset-0 bg-black opacity-50"></div>
        <div className="relative z-10 flex flex-col items-center justify-center text-center h-full text-white">
          <h1 className="text-4xl md:text-7xl xl:text-8xl font-semibold">Medical Delivery Services</h1>
        </div>
      </div>

      {/* Description Section */}
      <section className="py-12 px-6 bg-white text-black">
        <div className="max-w-4xl mx-auto text-center">
          <p className="text-lg font-thin leading-relaxed text-justify">{description}</p>
        </div>
      </section>

      {/* Services Section */}
      <section id="medical-services" className="py-16 bg-white text-white px-4">
        <div className="flex flex-col items-center gap-20">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-8">
            {services.map((service, index) => (
              <div
                key={index}
                className="flex flex-col gap-6 items-center text-center p-6 bg-gray-800 rounded-lg shadow-lg"
              >
                <h3 className="text-xl font-thin mb-4">{service.title}</h3>
                <p className="text-zinc-400 max-w-xl font-thin text-justify">{service.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Emergency Response Section */}
      <section className="py-12 px-6 bg-white text-black">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl font-thin mb-6">Emergency Response</h2>
          <p className="text-lg font-thin leading-relaxed text-justify">{emergencyResponse}</p>
        </div>
      </section>

      {/* Technology-Driven Solutions Section */}
      <section className="py-12 px-6 bg-white text-black">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl font-thin mb-6">Technology-Driven Solutions</h2>
          <p className="text-lg font-thin leading-relaxed text-justify">{technologySolutions}</p>
        </div>
      </section>
    </div>
  );
}

export default MedicalDeliveryServices;
